
<template>
<markdown-render v-if="guide" :source="guide"></markdown-render>
</template>

<script>
import { mapState } from 'vuex'
import MarkdownRender from '../../MarkdownRender'

export default {
  components:{
    "markdown-render": MarkdownRender
  },

  computed: {
    ...mapState(
      {
          http: state => state.metadata.backendApi.http[state.metadata.env]
      }
    )
  },
  data(){
    return {
      guide: null
    }
  },

  mounted(){
    this.guide = guide.replace('{{host}}',this.http.host).replace('{{basePath}}',this.http.basePath);
  }
  
}



const guide = "                                                                       \n\
# Getting started for FP-ATR-LTE1                                                     \n\
Please follow instructions [from here](https://www.st.com/en/embedded-software/fp-atr-lte1.htm) in order to configure properly your device \n\
## Register device and configure device                                       \n\
1. Connect device to local PC via USB \n\
2. Get device ID from serial terminal (e.g. TeraTerm)                                 \n\
3. Moving on dashboard, from **devices** view, regiester a new *FP-ATR-LTE1* device by providing:                   \n\
    - Human-friendly label                                                              \n\
    - Device ID  (got previously)                                                                       \n\
4. Download new device credentials from the displayed popup\n\
5. Via serial terminal, set private-key and certificate PEM strings just downloaded \n\
"
</script>
